import type {
  ResponsiveBreakpoint,
  ResponsiveOption,
  ResponsiveObject,
} from '../types/responsiveOption';

export function resolveResponsiveProps<T>(
  propValue: ResponsiveOption<T> | undefined
): {
  defaultOption: T | undefined;
  responsiveOption: ResponsiveBreakpoint<T> | undefined;
} {
  const isPropValueResponsive = isResponsiveObject(propValue);
  const defaultValue = isPropValueResponsive ? propValue.default : propValue;

  const responsiveValues =
    isPropValueResponsive && propValue
      ? {
          xs: propValue.xs,
          sm: propValue.sm,
          md: propValue.md,
          lg: propValue.lg,
          xl: propValue.xl,
        }
      : undefined;

  return { defaultOption: defaultValue, responsiveOption: responsiveValues };
}

function isResponsiveObject<T>(value: unknown): value is ResponsiveObject<T> {
  return (
    typeof value === 'object' &&
    value !== null &&
    !Array.isArray(value) &&
    ('default' in value ||
      'xs' in value ||
      'sm' in value ||
      'md' in value ||
      'lg' in value ||
      'xl' in value)
  );
}
